$(document).ready(function(){
  
  // General Message Display 2
  $('.generalmessage').prependTo('header');

  $('.mobile-nav-toggle').text('Menu');
  
  const ticketURL = $('.header .ticket').attr('href');
  $('.custom-buy-tickets-btn').attr('href', ticketURL);
  
  $('.homepage .section-tier-seven').prepend(`<img src="${FULLCLIENTTHEMEPATH}images/thankyou.png" id="thankyou" alt="thank you to our sponsors">`);
    
  // Subpage theme
  if ($('body').hasClass('subpage-theme')) {
    const firstSection = $('.entityContainerRow.rowIndex-1');
    const firstImage = firstSection.find('.ImageModule img').attr('data-src');
    $(`<div class="subpage-hero" style="background-image: url('${firstImage}')"></div>`).insertAfter('.header');
  }
  
  $(window).load(function () {
    $('.header .navMobileMenuShiftedGoBack').remove();
  })
  
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');

  $('div#weatherBugDescription').hide();

  setTimeout(function() {
    const temp = $('div#weatherBugDescription').text();
    $('div#weatherBugDescription').text(temp.slice(-4));
    if ($('body').hasClass('saffireLargeSize')) {
      $('div#weatherBugDescription').show();
    }
    if ($('body').hasClass('saffireMobileSize')) {
      $('div#weatherBugDescription').css('display', 'flex');
    }
    
  },2000);

  // clone social icons to footer
  $('.footer-social').append(`<div class="footer-social-links"></div>`);
  const sn = $('.socialNetworks a').clone();

  sn.each(function() {
    const link = $(this);
    const img = $(this).find('img');
    const imgSrc = img.attr('src');
    link.removeAttr('id');
    img.removeAttr('id');
    img.removeAttr('style');
    img.attr('src', imgSrc.replace('&w=40&h=40&cropBox=1&c=1', ''));
    $('.footer-social-links').append(link);
  });




});